import React from 'react';
import { gsap, Expo } from 'gsap';
import PropTypes from 'prop-types';

import useLanguage from '../../../../hooks/useLanguage';

import Gradient from '../../../UiComponents/Gradient/Gradient';
import FreeLessonModal from '../../../UiComponents/FreeLessonModal/FreeLessonModal';

import Star from '../../../../svg/star_shaddow.svg';
import TikTok from '../../../../svg/tik-tok.svg';
import Instagram from '../../../../svg/instagram.svg';
import Facebook from '../../../../svg/facebook.svg';
import Arrow from '../../../../svg/arr_right_down.svg';

const HomeMainScreen = ({
  mainData,
  mainStatic,
  mainSocials,
  freeLessonData,
}) => {
  const langToggle = useLanguage;

  const [tl] = React.useState(gsap.timeline({ paused: false }));
  let lineOne = React.useRef(null);
  let lineTwo = React.useRef(null);
  let lineThree = React.useRef(null);
  let bottomLine = React.useRef(null);
  let gradient = React.useRef(null);

  React.useEffect(() => {
    tl.to(lineOne, 1.5, { y: 0, opacity: 1, ease: Expo.easeOut, delay: 3.5 })
      .to(lineTwo, 1.5, { y: 0, opacity: 1, ease: Expo.easeOut, delay: -1.25 })
      .to(lineThree, 1.5, {
        y: 0,
        opacity: 1,
        ease: Expo.easeOut,
        delay: -1.25,
      })
      .to(bottomLine, 1.5, {
        y: 0,
        opacity: 1,
        ease: Expo.easeOut,
        delay: -1.25,
      })
      .to(gradient, 2.5, {
        y: 0,
        opacity: 1,
        ease: Expo.easeOut,
        delay: -1.7,
      });
  }, [tl]);

  const [open, setOpen] = React.useState(false);

  function openModal() {
    setOpen(true);
  }

  function closeModal() {
    setOpen(false);
  }

  return (
    <>
      <section id="top-section" className="home-main" data-scroll-section>
        <div className="home-main__center">
          <h1
            className="home-main__center-title"
            // data-scroll=""
            // data-scroll-speed="-1"
            // data-scroll-delay="0.05"
          >
            <span
              className="home-main__center-title__overflow"
              // data-scroll=""
              // data-scroll-speed="2"
              // data-scroll-position="top"
            >
              <span
                className="home-main__center-title__line"
                ref={(e) => (lineOne = e)}
              >
                {langToggle(mainData.title_01_ua, mainData.title_01_ru)}
              </span>
            </span>
            <span
              className="home-main__center-title__overflow"
              // data-scroll=""
              // data-scroll-speed="1.5"
              // data-scroll-position="top"
            >
              <span
                className="home-main__center-title__line"
                ref={(e) => (lineTwo = e)}
              >
                {langToggle(mainData.title_02_ua, mainData.title_02_ru)}
              </span>
            </span>
            <span
              className="home-main__center-title__overflow"
              // data-scroll=""
              // data-scroll-speed="1"
              // data-scroll-position="top"
              // data-scroll-delay="0.05"
            >
              {' '}
              <span
                className="home-main__center-title__line"
                ref={(e) => (lineThree = e)}
              >
                {langToggle(mainData.title_03_ua, mainData.title_03_ru)}
              </span>
            </span>
          </h1>
        </div>

        <div className="home-main__bottom">
          <div className="page-wrapper">
            <div
              className="home-main__bottom__container"
              ref={(e) => (bottomLine = e)}
            >
              <button
                // href="#second-section"
                // data-scroll-to
                className="home-main__scrollDown"
                onClick={openModal}
              >
                <span className="home-main__scrollDown-icon">
                  <Star className="home-main__scrollDown-icon__star" />
                  <Arrow className="home-main__scrollDown-icon__arrow" />
                </span>
                <span className="home-main__scrollDown-title__overflow">
                  <span className="home-main__scrollDown-title">
                    {langToggle(mainStatic.title_ua, mainStatic.title_ru)}
                  </span>
                </span>
              </button>
              <ul className="home-main__socials">
                {mainSocials.map((item, index) => {
                  return (
                    <li className="home-main__socials-item" key={index}>
                      <a
                        href={item.link}
                        className="home-main__social-link"
                        target="blank"
                      >
                        <span className="home-main__social-icon">
                          <Star className="home-main__social-icon__star" />
                          {item.title === 'Tik Tok' ? (
                            <TikTok className="home-main__social-icon__logo" />
                          ) : item.title === 'Instagram' ? (
                            <Instagram className="home-main__social-icon__logo" />
                          ) : item.title === 'Facebook' ? (
                            <Facebook className="home-main__social-icon__logo" />
                          ) : null}
                        </span>
                        <span className="home-main__social-title__overflow">
                          <span className="home-main__social-title">
                            {item.title}
                          </span>
                        </span>
                      </a>
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
        </div>
        <div
          className="gradient-wrapper"
          // data-scroll=""
          // data-scroll-speed="2.5"
          // data-scroll-delay="0.05"
        >
          <div
            className="gradient-wrapper__owerflow"
            ref={(e) => (gradient = e)}
          >
            <Gradient />
          </div>
        </div>
      </section>
      <FreeLessonModal
        open={open}
        closeModal={closeModal}
        title={langToggle(freeLessonData.title_ua, freeLessonData.title_ru)}
      />
    </>
  );
};

HomeMainScreen.propTypes = {
  mainData: PropTypes.object,
  mainStatic: PropTypes.object,
  mainSocials: PropTypes.array,
  freeLessonData: PropTypes.object,
};

export default HomeMainScreen;
